// Sessions live only in HttpOnly cookies set by the backend. Older versions kept
// the tokens in localStorage; this removes such leftovers.
export function removeTokens() {
  try {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
  } catch {
    // storage unavailable: nothing to remove
  }
}
